<div class="wrapper">
    @if (isActionAllowed()) {
        <div class="addTeamMember">
            <lib-generic-type-ahead-dropdown
                [(selectedItem)]="selectedUser"
                placeholder="Add Team Member"
                (selectedItemChange)="onSelectedUser()"
                [displaySelected]="false"
                [(text)]="usersSearchText"
                [source]="usersSearchResult"
                (textChange)="onUsersTextChanged()"
                [config]="{
                    defaultText: 'Add Team Member',
                    itemDisplayKey: 'fullName',
                    itemTemplate: userTemplate
                }"
            >
            </lib-generic-type-ahead-dropdown>
            <ng-template #userTemplate let-data>
                <app-custom-menu-item
                    [inputText]="data.inputText"
                    [title]="
                        $safeNavigationMigration(data.object?.firstName) +
                        ' ' +
                        $safeNavigationMigration(data.object?.lastName)
                    "
                    [subtitle]="data.object?.email ?? ''"
                >
                </app-custom-menu-item>
            </ng-template>
        </div>
    }

    @if (usersDatasource) {
        <div class="grid">
            <app-server-side-grid
                [colDefs]="gridColumns"
                [datasource]="usersDatasource"
                [noRows]="noResults()"
                [titleNoData]="'No Team Members available.'"
                [getRowId]="getRowIdFn"
            ></app-server-side-grid>
        </div>
    }
</div>
